import { SvgIcon } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { ReactComponent as CrownSvg } from "../assets/IconCrown.svg";
import { ReactComponent as TrackSvg } from "../assets/IconTrack.svg";
import { ReactComponent as CurateSvg } from "../assets/IconCurate.svg";

// The app's own nav icons (Track, Curate) have their own viewBox and, unlike
// MUI's icons, no built-in margin — scaled down to match MUI's visual size
// while keeping the same 1em footprint
const NAV_ICON_SCALE = { transform: "scale(0.85)" };
const withNavIconScale = (sx) => [
  NAV_ICON_SCALE,
  ...(Array.isArray(sx) ? sx : [sx]),
];

// App-wide icons for Curate concepts, so each one looks the same everywhere and
// can be swapped in one place. They take MUI SvgIcon props (color, fontSize, sx).

/**
 * All-time Top 5. Google Material Symbols "crown" (filled) — its SVG uses a
 * 0 -960 960 960 viewBox, hence inheritViewBox.
 */
export function CrownIcon(props) {
  return <SvgIcon component={CrownSvg} inheritViewBox {...props} />;
}

/** Track (the library), as in the nav drawer. */
export function TrackIcon({ sx, ...props }) {
  return (
    <SvgIcon
      component={TrackSvg}
      inheritViewBox
      sx={withNavIconScale(sx)}
      {...props}
    />
  );
}

/** Curate (collections), as in the nav drawer. */
export function CurateIcon({ sx, ...props }) {
  return (
    <SvgIcon
      component={CurateSvg}
      inheritViewBox
      sx={withNavIconScale(sx)}
      {...props}
    />
  );
}

/** Standouts. MUI's "EmojiEvents" (a trophy) — legible at small sizes. */
export function StandoutIcon(props) {
  return <EmojiEventsIcon {...props} />;
}

/**
 * TV, filled: MUI's "LiveTvRounded" with its screen solid and the play triangle
 * cut out (evenodd), to match the solid movie and book icons. Built from MUI's
 * own path data, minus the inner screen outline that made it hollow.
 */
export function LiveTvFilledIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        d="M21 6h-7.59l2.94-2.94c.2-.2.2-.51 0-.71s-.51-.2-.71 0L12 5.99 8.36 2.35c-.2-.2-.51-.2-.71 0s-.2.51 0 .71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm-10.5 11.15 3.98-2.28c.67-.38.67-1.35 0-1.74l-3.98-2.28c-.67-.38-1.5.11-1.5.87v4.55c0 .77.83 1.26 1.5.88z"
      />
    </SvgIcon>
  );
}

/**
 * Progress (the dashboard's Progress section). A pie two-thirds filled, which
 * MUI doesn't offer: the filled slice runs clockwise from 12 o'clock through
 * 67% (241.2°), and the rest of the disc is a faint remainder in the same colour.
 */
export function ProgressIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 12V2a10 10 0 1 1-8.76 14.82Z" />
      <path d="M12 12 3.24 16.82A10 10 0 0 1 12 2Z" opacity={0.3} />
    </SvgIcon>
  );
}
